import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {COBI_HIERARCHY, formatCobiYear} from "../misc/Shared";

const propTypes = {
	admin: PropTypes.bool.isRequired,
	currentCobiId: PropTypes.number,
	currentYear: PropTypes.number,
	currentTab: PropTypes.string,
	draft:	PropTypes.bool,
	menuObj: PropTypes.object.isRequired,
};

const defaultProps = {
	currentCobiId: undefined,
	currentYear: undefined,
};

// Props connected to the store
const mapStateToProps = (state) => {
    return {
		admin: state.app.admin,
		currentCobiId: state.app.currentCobiId,
		currentYear: state.app.currentYear,
		currentTab: state.app.currentTab,
		draft: state.app.draft,
		menuObj: state.menu.menuObj,
		currentFund: state.app.currentFund
	};
};

class Breadcrumb extends React.Component {
	constructor(props) {
		super(props);

		this.menu = [COBI_HIERARCHY.SUBCOMMITTEE, COBI_HIERARCHY.AGENCY, COBI_HIERARCHY.LINE_ITEM, COBI_HIERARCHY.PROGRAM];
	}

	generateBreadcrumbs() {
		let breadcrumbs = this.menu.map(list => {
            const items = this.props.menuObj[list];
            if (items) {
                for (let i = 0; i < items.length; i++) {
                    if (items[i].selected) {
                        return (
							<li key={'breadcrumbs' + items[i].cobiId} id={'breadcrumb-' + list}>
								{items[i].cobiId === this.props.currentCobiId ? items[i].orgName : <Link to={`${this.props.admin ? '/admin/editor' : ''}/${this.props.currentYear}/${items[i].cobiId}/${this.props.currentTab}${this.props.draft && !this.props.admin ? '/draft' : ''}`}>
                                    {items[i].orgName}
								</Link>}
							</li>
                    	);
                    }
				}
            }
		});
		breadcrumbs.unshift(
			<li key={'breadcrumbsYear'} id="breadcrumb-cobi">
				{this.props.currentCobiId === 1 && !this.props.currentFund ? `COBI ${formatCobiYear(this.props.currentYear)}` : <Link to={`${this.props.admin ? '/admin/editor' : ''}/${this.props.currentYear}/1/${this.props.currentTab}${this.props.draft && !this.props.admin ? '/draft' : ''}`}>
					COBI {formatCobiYear(this.props.currentYear)}
				</Link>}
			</li>
		);
		return breadcrumbs;
	}

	render() {
		return (
			<ul className="breadcrumb flex1">
                {this.generateBreadcrumbs()}
			</ul>
		);
	}
}

Breadcrumb.propTypes = propTypes;
Breadcrumb.defaultProps = defaultProps;

export default connect(mapStateToProps)(Breadcrumb);